module.exports = __webpack_public_path__ + "img/home-2-891x535.877402d9.png";